import axios from '@/utils/request/index.js'

const save = async (body) => {
  try {
    const { data } = await axios.post('/file/save', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const details = async (body) => {
  try {
    const { data } = await axios.post('/form/temp/details', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const update = async (body) => {
  try {
    if (body.zzid == '0' || body.zzid == 0) {
      delete body.zzid
    }
    const { data } = await axios.post('/form/data/upJson', {
      ...body
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}





export default {
  save,
  details,
  update,
}